// extracted by mini-css-extract-plugin
module.exports = {"unauthorized__wrapper":"Page401_unauthorized__wrapper__Enylh"};